export const EXPERIMENT_SMART_METRIC_SCHEMA_NAME =
  'experiment_smart_metrics.SmartMetric';
export const EXPERIMENT_SMART_METRIC_MINIEVENT_NAME = 'SmartMetric';
